"use client";

import { useTranslations } from "next-intl";

import { Badge } from "@/components/ui/badge";
import { buttonVariants } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Typography } from "@/components/ui/typography";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { Link } from "@/i18n/routing";
import { cn } from "@/lib/utils";
import { ROUTES } from "@/routes";

export const UserBox = () => {
    const t = useTranslations("profile.userBox");

    const user = useCurrentUser();

    return (
        <Card className="bg-accent">
            <CardContent className="p-4">
                {!user ? (
                    <Skeleton className="h-[148px] max-w-full" />
                ) : (
                    <div className="flex flex-col">
                        <Typography variant={ "h3" } className="truncate" title={ `${ user.firstName } ${ user.lastName }` }>
                            {user.firstName} {user.lastName}
                        </Typography>
                        <Typography title={ user.email! } className="truncate">
                            {user.email}
                        </Typography>
                        <div className="flex items-center truncate">
                            <Typography className="w-10">{t("role")} : </Typography>
                            <Typography variant={ "muted" }>{t(user.role.toLowerCase())}</Typography>
                        </div>
                        <div className="flex items-center">
                            <Typography className="w-10">2FA : </Typography>
                            <Badge variant={ user.isTwoFactorEnabled ? "success" : "destructive" }>
                                {user.isTwoFactorEnabled ? t("enabled") : t("disabled")}
                            </Badge>
                        </div>
                        <Link href={ ROUTES.SETTINGS } className={ cn("mt-2", buttonVariants({ variant: "default" })) } >
                            {t("editProfile")}
                        </Link>
                    </div>
                )}
            </CardContent>
        </Card>
    );
};
